
@if (isReady) {
  <app-graph-mixed [config]="graphConfigObs"></app-graph-mixed>
} @else {
  @if (showLoader) {
    <div class="center spinner-container">
      <app-fake-stepper [options]="loaderOptions"></app-fake-stepper>
    </div>
  }
}